import { OperationResult } from '@vp/common/core/OperationResult';
import { RefineBiographyDto } from '@vp/manager/biography/core/dto/RefineBiographyDto';
import { UpdateBiographyDto } from '@vp/manager/biography/core/dto/UpdateBiographyDto';
import { ProfileModel } from '@vp/profile/core/model/ProfileModel';

export abstract class BiographyManagerRepository {
  abstract refine(dto: RefineBiographyDto, controller?: AbortController): Promise<OperationResult<string>>;
  abstract update(dto: UpdateBiographyDto, controller?: AbortController): Promise<OperationResult<ProfileModel>>;
}
